var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwimming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "l9zspauqra",
    d: "M0.324 0.981L18.676 0.981 18.676 6 0.324 6z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B0F0FF",
    d: "M23 11.5c0 6.351-5.149 1.192-11.5 1.192S0 17.851 0 11.5 5.149 0 11.5 0 23 5.149 23 11.5"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 14.43)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "kbfe0nsegb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l9zspauqra"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#003DB3",
    d: "M12.978.981c-1.197 0-2.197.84-2.447 1.961H8.47C8.22 1.82 7.22.982 6.022.982 4.636.981.324 2.104.324 3.491.324 4.875 4.636 6 6.022 6 7.22 6 8.218 5.161 8.47 4.04h2.062C10.781 5.16 11.781 6 12.978 6c1.386 0 5.698-1.124 5.698-2.509 0-1.386-4.312-2.51-5.698-2.51",
    mask: "url(#kbfe0nsegb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B0F0FF",
    d: "M4.868 18.838c-.058 0-.115-.024-.157-.07-.077-.087-.07-.22.018-.296l1.56-1.38c.086-.078.219-.07.296.017.077.086.068.22-.018.296l-1.56 1.38c-.04.036-.09.053-.14.053M6.248 18.838c-.058 0-.115-.024-.157-.07-.077-.087-.07-.22.018-.296l1.56-1.38c.086-.078.219-.07.296.017.077.086.068.22-.018.296l-1.56 1.38c-.04.036-.09.053-.14.053"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwimming);
export default __webpack_public_path__ + "static/media/swimming.ea836319edd3ec136d88d821315d312a.svg";
export { ForwardRef as ReactComponent };